import type { SucVenta } from '../services/sucVentaService';

export type SucVentaImpresionTicket = Pick<SucVenta, 'imprime' | 'tipoImpresora'>;

export const NRO_TIPO_FORMULARIO_FACTURA_VENTA_SUCVENTA = '1';
export const TIPO_IMPRESORA_TICKETERA_EPSON = 'TE';

export type ModoImpresionFacturaVenta = 'ticketera' | 'pdf';

const IMPRIME_SI = 'S';

export function debeImprimirAutomaticoPos(sucVenta: SucVentaImpresionTicket | null | undefined): boolean {
  if (!sucVenta) return false;
  return String(sucVenta.imprime ?? '').trim().toUpperCase() === IMPRIME_SI;
}

export function usaTicketeraEpson(sucVenta: SucVentaImpresionTicket | null | undefined): boolean {
  if (!sucVenta) return false;
  return String(sucVenta.tipoImpresora ?? '').trim().toUpperCase() === TIPO_IMPRESORA_TICKETERA_EPSON;
}

export function debeImprimirTicketEscPos(sucVenta: SucVentaImpresionTicket | null | undefined): boolean {
  return debeImprimirAutomaticoPos(sucVenta) && usaTicketeraEpson(sucVenta);
}

export function nombreImpresoraTicketSucVenta(
  sucVenta: SucVenta | null | undefined,
  letra?: string | null,
): string | null {
  if (!sucVenta) return null;
  const letraNorm = String(letra ?? '').trim().toUpperCase();
  const porLetra: Record<string, string | undefined> = {
    A: sucVenta.impA,
    B: sucVenta.impB,
    C: sucVenta.impC,
    N: sucVenta.impN,
  };
  const nombre = String(porLetra[letraNorm] ?? sucVenta.impComun ?? '').trim();
  return nombre || null;
}

export function motivoNoTicketEscPos(
  sucVenta: SucVenta | null | undefined,
  nroSuc: number,
  nroTipoFormulario = NRO_TIPO_FORMULARIO_FACTURA_VENTA_SUCVENTA,
): string {
  if (!nroSuc || nroSuc <= 0) {
    return 'No hay sucursal seleccionada en el POS.';
  }
  if (!sucVenta) {
    return `No hay SucVenta para sucursal ${nroSuc} y tipo formulario ${nroTipoFormulario} (Factura venta). Configuralo en Configuraciones → SucVenta.`;
  }
  const imprime = String(sucVenta.imprime ?? '').trim().toUpperCase();
  if (imprime !== IMPRIME_SI) {
    return `SucVenta sucursal ${nroSuc}: activá "Imprime" (ahora: ${imprime || 'N'}).`;
  }
  const tipo = String(sucVenta.tipoImpresora ?? '').trim().toUpperCase();
  if (tipo !== TIPO_IMPRESORA_TICKETERA_EPSON) {
    return `SucVenta sucursal ${nroSuc}: elegí "Ticketera EPSON" (ahora: ${tipo || 'vacío'}).`;
  }
  return '';
}
